module.exports = __webpack_public_path__ + "assets/img/portfolio-10.54443462.png";